module.exports = __webpack_public_path__ + "static/media/trash.4863e1c0.svg";